module.exports = __webpack_public_path__ + "img/copyright.152df40e.png";